import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import Drawer from '@mui/material/Drawer'
import Hidden from '@mui/material/Hidden'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useTheme, Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import {
  IStudentTeacherDashboardSidebar,
  student_teacher_dashboard_sidebar,
} from './student_teacher_dashboard_sidebar'

import ProfileImageComponent from '../../../components/ProfileImageComponents/ProfileImageComponent'
import InfoAppBar from '../../../components/SchoolHomepage/DefaultHomepage/InfoAppBar'
import { ISchool } from '../../../interfaces/school.interface'
import { CircularProgress, Divider, Typography } from '@mui/material'
import useSchoolUserDetails from '../../../components/School/useSchoolUserDetails'
import { IUserType } from '../../../interfaces/user.interface'
import { StudentTeacherDashboardTabs } from './StudentTeacherDashboardTabs'
import { useIsSmallScreen } from '../../../components/utilsHooks/useIsSmallScreen'
import SchoolLogoutListItem from '../../../components/School/SchoolLogoutListItem'
import Link from 'next/link'

const drawerWidth = 310

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      // zIndex: theme.zIndex.drawer + 1,
      // [theme.breakpoints.up("sm")]: {
      //   width: `calc(100% - ${drawerWidth}px)`,
      //   marginLeft: drawerWidth,
      // },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: '#fafafa',
      zIndex: theme.zIndex.appBar - 1,
      borderRight: 'none',
      // backgroundColor: "#22282d",
      // backgroundColor: theme.palette.primary.dark,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      backgroundColor: '#fafafa',
      minHeight: '100vh',
    },
  }),
)

interface Props {
  container?: any // for material-ui
  children?: any // for react
  schoolDetails: ISchool
  userId: string
  userType: IUserType
  customContentStyle?: any
}

export default function StudentTeacherDashboardResponsiveDrawer(props: Props) {
  const classes = useStyles()
  const theme = useTheme()
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [sidebar, setSidebar] = React.useState<IStudentTeacherDashboardSidebar>(
    [],
  )
  const isSmallScreenHook = useIsSmallScreen() // useMediaQuery(theme.breakpoints.down("xs"));
  const { isSmallScreen } = isSmallScreenHook

  React.useEffect(() => {
    if (props.userType === 'teacher' || props.userType === 'student') {
      setSidebar(
        student_teacher_dashboard_sidebar(props.userType, props.schoolDetails),
      )
    }
  }, [])

  console.log(props)

  const schoolUserDetailsHook = useSchoolUserDetails(
    props.userId,
    props.schoolDetails._id,
    props.userType,
  )

  const schoolUserDetails = schoolUserDetailsHook.details

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const selectedSidebar = (sidebarItemUrl: string) => {
    return (
      typeof location !== 'undefined' && location.pathname === sidebarItemUrl
    )
  }

  if (!props.userType) {
    return <CircularProgress size={20} />
  }

  const drawer = (
    <div style={{ height: '100vh' }}>
      <div
        // style={{ backgroundColor: theme.palette.primary.dark }}
        className={classes.toolbar}
      />
      <Divider />
      <div>
        <div style={{ height: '30px' }} />
        <ProfileImageComponent
          // textColor={theme.palette.primary.contrastText}
          // textColor={"#fff"}
          imageUrl={schoolUserDetails && schoolUserDetails.picture}
          primaryText={schoolUserDetails ? schoolUserDetails.name : ''}
          secondaryText={schoolUserDetails ? schoolUserDetails.email : ''}
          subText={schoolUserDetails ? schoolUserDetails.user_code : ''}
        />
      </div>

      <List dense={true}>
        {sidebar.map((item, index) => {
          const isSelected = selectedSidebar(item.link)
          const style = isSelected
            ? {
                backgroundColor: '#0000001f',
                // backgroundColor: theme.palette.primary.main,
                // color: theme.palette.primary.contrastText,
                // backgroundColor: "#eadcef40",
              }
            : {}

          const iconStyle = isSelected
            ? {
                color: theme.palette.primary.main,
                // color: '#fff',
              }
            : {
                // color: theme.palette.primary.main,
              }

          return (
            // <Link key={index} href={item.link}>
            <ListItem
              component={Link}
              href={item.link}
              button={true}
              style={{
                // color: theme.palette.primary.contrastText,
                borderRadius: '10px',
                width: '90%',
                margin: '4px 10px',
                ...style,
              }}
              key={index}
            >
              <ListItemIcon>
                {item.icon && (
                  <item.icon
                    style={{
                      ...iconStyle,
                    }}
                  />
                )}
              </ListItemIcon>
              <ListItemText>
                <Typography>{item.label}</Typography>
              </ListItemText>
            </ListItem>
            // </Link>
          )
        })}
      </List>
      <List>
        <SchoolLogoutListItem
          customStyle={{
            // border: "1px solid #998c8c33",
            borderRadius: '0px 20px 20px 0px',
            width: '90%',
            margin: '10px 10px',
            marginTop: '20px',
            // color: theme.palette.primary.contrastText,
          }}
        />
      </List>
      {/*<div*/}
      {/*  style={{*/}
      {/*    height: "60px",*/}
      {/*  }}*/}
      {/*/>*/}
      {/*<div*/}
      {/*  style={{*/}
      {/*    display: "flex",*/}
      {/*    // marginTop: "50px",*/}
      {/*    marginLeft: "10px",*/}
      {/*    marginBottom: "10px",*/}
      {/*    justifyContent: "start",*/}
      {/*    opacity: 0.7,*/}
      {/*    // position: "fixed",*/}
      {/*    bottom: "10px",*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <SchoolLogo school={props.schoolDetails} />*/}
      {/*</div>*/}
    </div>
  )

  return (
    <div className={classes.root}>
      <CssBaseline />
      <div>
        <InfoAppBar
          showMenuButton={isSmallScreen}
          onMenuButtonClicked={handleDrawerToggle}
          // hideButtons={!this.state.user_details}
          school_details={props.schoolDetails}
          appbarStyle={
            {
              // boxShadow: "none",
              // borderBottom: "1px solid #7575752b",
            }
          }
        />
      </div>

      <div style={{ height: '62px' }} />
      <nav className={classes.drawer}>
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden mdDown={true} implementation="css">
          <Drawer
            container={props.container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden mdDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content} style={{ ...props.customContentStyle }}>
        <div className={classes.toolbar} />
        {props.children}
        {isSmallScreen && (
          <div>
            <StudentTeacherDashboardTabs schoolDetails={props.schoolDetails} />
          </div>
        )}
      </main>
    </div>
  )
}
